import { jsx } from "@ecopages/jsx/jsx-runtime";
import "./toolbar.script";
export function RuiToolbar({
  children,
  label,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-toolbar", {
    ...props,
    label,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-toolbar",
      "data-ref": "root",
      role: "toolbar",
      "aria-label": label || void 0,
      children
    })
  });
}